import { AxiosInstance } from "axios"
import { ApiResponse } from "../../models/api"
import { Plan } from "../../models/plan"

export type ContactFormData = {
  firstName: string
  lastName: string
  from: string
  company: string
  phoneNumber?: string
  message: string
  formType: string
  howDidYouHearAboutUs: string
}

export type EmailInterestData = {
  from: string
  message?: string
}

export interface GetPlansParams {
  limit?: number
  page?: number
  paginate?: boolean
}

export class ContactFormApi {
  private client: AxiosInstance

  constructor(client: AxiosInstance) {
    this.client = client
  }

  execute = (data: ContactFormData) => this.client.post("mails/contact-form", data)
  executeEmailInterest = (data: EmailInterestData) => this.client.post("mails/email-interest", data)
}

export class PlansApi {
  private client: AxiosInstance

  constructor(client: AxiosInstance) {
    this.client = client
  }

  getPlans = (params?: GetPlansParams) =>
    this.client.get<ApiResponse<Plan>>("plans", {
      params: {
        limit: params?.limit ?? 20,
        page: params?.page ?? 1,
        paginate: params?.paginate ?? true,
      },
    })
}
